(function () {
    'use strict';

    var controllerId = 'ExternalSignInController';

    angular.module('app.core')
        .controller(controllerId, ['$scope', '$window', 'notifierSvc', 'appActivitySvc', '$translate', '$state', '$timeout', 'ngDialog', 'auth_factory', 'userSvc', ExternalSignInController]);

    function ExternalSignInController($scope, $window, notifierSvc, appActivitySvc, $translate, $state, $timeout, ngDialog, auth_factory, userSvc) {
        $scope.authProviders = undefined;
        $scope.loginExternal = {
            apple: false,
            google: false,
            other: false,
            emlakjet: false
        };
        $scope.login = login;
        $scope.loginWithEmlakjet = loginWithEmlakjet;
        $scope.confirmEjMerge = confirmExternalLoginAdditionalConfirmation;

        var pendingExternalLoginData = null;
        var pendingExternalLoginProviderKey = null;
        var externalLoginConfirmationDialog = null;

        getAuthProviders();

        AppleID.auth.init({
            clientId: 'com.endeksa.ios.client',
            scope: 'name email',
            redirectURI: 'https://' + location.host + '/' + window.lang + '/signin',
            state: 'origin:web',
            usePopup: true
        });

        $scope.loginWithApple = function () {
            $timeout(function () {
                $scope.loginExternal.apple = true;
            });
            const data = AppleID.auth.signIn().then(data => {
                console.log(data);
                if (data.user) {
                    var email = data.user.email ? data.user.email : null;
                    var name = data.user.name ? data.user.name.firstName : null;
                    var lastName = data.user.name ? data.user.name.lastName : null;

                    appleSignin(data.authorization.id_token, name, lastName, email);
                } else {
                    appleSignin(data.authorization.id_token);
                }
            }).catch(e => {
                $timeout(function () {
                    $scope.loginExternal.apple = false;
                });
                console.log(e);
            });
        };

        function onSignin() {
            gapi.load('auth2', function () {
                // Retrieve the singleton for the GoogleAuth library and set up the client.
                gapi.auth2.init({
                    client_id: '760143033845-7vhleskmthauri8uq2kfn45dr0frga3b.apps.googleusercontent.com',
                    cookiepolicy: 'single_host_origin',
                    // Request scopes in addition to 'profile' and 'email'
                    //scope: 'additional_scope'
                }).then(function (auth2) {
                    attachSignin(document.getElementById('endeksa-signin2'), auth2);
                }, function (error) {
                    console.log(error);
                });

            });
        }

        function appleSignin(token, name = null, lastName = null, email = null) {
            signInExternalWithConfirmation({ provider: 'Apple', token: token, name: name, surName: lastName, email: email }, 'apple');
        }

        function signInExternalWithConfirmation(data, providerKey) {
            userSvc.externalLoginConfirm(data).then(
                function (isRequired) {
                    if (isRequired === true) {
                        setExternalLoginLoading(providerKey, false);
                        openExternalLoginAdditionalConfirmationDialog(data, providerKey);
                        return;
                    }
                    completeExternalSignIn(data, providerKey);
                },
                function () {
                    setExternalLoginLoading(providerKey, false);
                }
            );
        }

        function openExternalLoginAdditionalConfirmationDialog(data, providerKey) {
            pendingExternalLoginData = angular.copy(data);
            pendingExternalLoginProviderKey = providerKey;
            externalLoginConfirmationDialog = ngDialog.open({
                templateUrl: 'app/security/ej-merge-confirmation.modal.html',
                scope: $scope,
                showClose: false,
                closeByEscape: false,
                closeByDocument: false,
                closeByNavigation: false
            });
        }

        function confirmExternalLoginAdditionalConfirmation(isConfirmed) {
            if (!pendingExternalLoginData || !pendingExternalLoginProviderKey) {
                return;
            }

            pendingExternalLoginData.IsEjMergeConfirmed = isConfirmed;
            if (externalLoginConfirmationDialog) {
                externalLoginConfirmationDialog.close();
                externalLoginConfirmationDialog = null;
            }

            var data = pendingExternalLoginData;
            var providerKey = pendingExternalLoginProviderKey;
            pendingExternalLoginData = null;
            pendingExternalLoginProviderKey = null;
            setExternalLoginLoading(providerKey, true);
            completeExternalSignIn(data, providerKey);
        }

        function completeExternalSignIn(data, providerKey) {
            userSvc.signInExternal(data).then(
                function () {
                    setExternalLoginLoading(providerKey, false);
                    $window.location.reload();
                },
                function () {
                    setExternalLoginLoading(providerKey, false);
                }
            );
        }

        function setExternalLoginLoading(providerKey, isLoading) {
            $timeout(function () {
                $scope.loginExternal[providerKey] = isLoading;
            });
        }

        function attachSignin(element, auth2) {
            auth2.attachClickHandler(element, {},
                function (googleUser) {
                    $scope.loginExternal.google = true;
                    $scope.$apply();
                    var dataObj = {
                        provider: 'Google',
                        isMobile: false,
                        token: googleUser.getAuthResponse().id_token
                    };
                    signInExternalWithConfirmation(dataObj, 'google');
                }, function (error) {
                    $timeout(function () {
                        $scope.loginExternal.google = false;
                    });
                    console.log(JSON.stringify(error, undefined, 2));
                });
        }


        function login(url) {
            // ngDialog.close();
            // ngDialog.open({
            //     templateUrl: 'app/shell/modal-wait.html'
            // });
            $state.go('signin', { langcode: $window.lang }); //added to remember the state, otherwise it doesnt realisethe state change
            $timeout(function () {
                $window.location.href = url;
            }, 500);
        }

        function loginWithEmlakjet() {
            $timeout(function () {
                $scope.loginExternal.emlakjet = true;
            });
            auth_factory.emlakjetLogin().$promise.then(
                function (result) {
                    if (result && result.authorizeUrl) {
                        $window.location.href = result.authorizeUrl;
                    } else {
                        $timeout(function () {
                            $scope.loginExternal.emlakjet = false;
                        });
                        notifierSvc.show({ message: $translate.instant('emlakjet_signin_error'), type: "error" });
                    }
                },
                function (error) {
                    console.log(error);
                    $timeout(function () {
                        $scope.loginExternal.emlakjet = false;
                    });
                    notifierSvc.show({ message: $translate.instant('emlakjet_signin_error'), type: "error" });
                }
            );
        }

        function getAuthProviders() {
            appActivitySvc.busy("ExternalSignInController");
            $scope.loadingExternalButtons = true;

            auth_factory.externallogins().$promise.then(
                function (result) {
                    $scope.authProviders = result;
                    onSignin();
                },
                function (reject) {
                    var account = $translate.instant('external_account_client');
                    notifierSvc.show({ message: account, type: "error" });
                }
            )['finally'](
                function () {
                    appActivitySvc.idle("ExternalSignInController");
                    $scope.loadingExternalButtons = false;
                });
        }
    }
})();
